import React, { useEffect } from "react";
import { connect } from "react-redux";
import { 
	getWidgetData
} from "../../../redux/dashboard/dashboardState";
import MiniCalendar from "components/calendar/MiniCalendar";
import PieChartCard from "views/console/default/components/PieChartCard";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";

import { columnsDataComplex } from "./variables/columnsData";
import { topFarmers, topFarmerColumn } from "./variables/tableDataFarmers";

import Widget from "components/widget/Widget";
import ComplexTable from "views/console/default/components/ComplexTable";
import DailyTraffic from "views/console/default/components/DailyTraffic";
import tableDataComplex from "./variables/tableDataComplex.json";
import FarmersList from "views/console/default/components/FarmersList";
import RegisteredAnimalsChart from "views/console/default/components/RegisteredAnimalsChart";
import AnimalsStatusChart from "views/console/default/components/AnimalsStatusChart";
import PhilippinesMap from "views/console/default/components/PhilippinesMap";
import WeeklyRevenue from "./components/WeeklyRevenue";
import RegisteredUsersChart from "./components/RegisteredUsersChart";

const Dashboard = ({getWidgetsData, widgetData, requesting, success, error, ...props}) => {
  useEffect(() => {
      //getWidgetsData(null);
  }, [getWidgetsData]);

  return (
    <div className="mt-5">
      
      {/* Card widgets */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<IoDocuments className="h-6 w-6" />}
          title={"Registered Animals"}
          subtitle={widgetData?.animalsCount ?? 0}
        />

        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Breed Events"}
          subtitle={widgetData?.totalEarnedPoints ?? 0}
        />  

        <Widget
          icon={<MdDashboard className="h-7 w-7" />}
          title={"Online Staff"}
          subtitle={widgetData?.farmersCount ?? 0}
        />
              
      </div>

      <div className="mt-3 grid grid-cols-1 gap-5 lg:grid-cols-2 3xl:grid-cols-3">
        
        <RegisteredAnimalsChart/>

        <AnimalsStatusChart/>

      </div>
      
    </div>
  );
};

const mapStateToProps = (state) => ({
    requesting: state.dashboard.widgetsData?.requesting,
    success: state.dashboard.widgetsData?.succcess,
    error: state.dashboard.widgetsData?.error,
    widgetData: state.dashboard.widgetsData.data,
});

const mapDispatchToProps = (dispatch) => ({
  getWidgetsData: () => dispatch(getWidgetData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
